var _g, _path, _g2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_582_964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4548 21.7504C14.6743 23.0227 12.8257 23.0227 12.0452 21.7504L4.36006 9.22241C3.54259 7.88979 4.50148 6.17663 6.06486 6.17663L21.4351 6.17662C22.9985 6.17662 23.9574 7.88979 23.1399 9.22241L15.4548 21.7504Z",
    fill: "#F25B5B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3072 20.3609C15.1365 22.2693 12.3635 22.2693 11.1928 20.3609L5.29426 10.7453C4.06804 8.74638 5.50639 6.17663 7.85145 6.17663L19.6485 6.17662C21.9936 6.17662 23.432 8.74637 22.2057 10.7453L16.3072 20.3609Z",
    fill: "#F25B5B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_582_964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4026 22.1285C14.6087 23.2932 12.8913 23.2932 12.0974 22.1285L4.62262 11.1619C3.71771 9.83426 4.66855 8.03548 6.27525 8.03548L21.2248 8.03548C22.8315 8.03548 23.7823 9.83426 22.8774 11.1619L15.4026 22.1285Z",
    fill: "#F25B5B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.3072 22.8315C15.1365 24.7399 12.3635 24.7399 11.1928 22.8315L5.29426 13.2159C4.06804 11.217 5.50639 8.64721 7.85145 8.64721L19.6485 8.64721C21.9936 8.64721 23.432 11.217 22.2057 13.2159L16.3072 22.8315Z",
    fill: "#F25B5B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_582_964",
    x: 1.06177,
    y: 3.17664,
    width: 25.3765,
    height: 22.5281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_582_964"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_582_964",
    x: 1.27185,
    y: 5.03552,
    width: 24.9563,
    height: 20.9666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_582_964"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnder);
export default __webpack_public_path__ + "static/media/under.0f74edda.svg";
export { ForwardRef as ReactComponent };